import React, {useEffect} from 'react';
import { useHistory } from "react-router-dom";
import Header from '../components/Header';
import '../styles/info.css';
import config from '../config';

export default function Info(props) {
    const history = useHistory();

    useEffect(() => {
        document.title = "Info"
    }, []);

    return (
        <div className="container">
            <div className="main info">
                <Header/>
                <p className="heading mt-3">Information</p>
                <div className='wrapper'>
                    <div className="card">
                        <a href={config.factSheetLink} without='true' rel="noopener noreferrer" target="_blank">
                            <div className="card-body">
                                iSelfie Test for COVID Fact Sheet
                            </div>
                        </a>
                    </div>
                    <div className="card">
                        <a href='https://www.aiztechlabs.com/privacy' without='true' rel="noopener noreferrer" target='_blank'>
                            <div className="card-body">
                                Privacy Policy
                            </div>
                        </a>
                    </div>
                    <div id="aboutus" className="card" onClick={() => history.push("/aboutus")}>
                        <div className="card-body">About Us</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
